import Axios from "axios";

function getTokenFromCookies(name) {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((c) => c.startsWith(`${name}=`));

  if (!cookie) return null;

  return decodeURIComponent(cookie.split("=")[1]);
}

/**
 * Global configuration file for the api baseUrl
 *
 * @module Config
 */
const Config = (() => {
  const REMOTE_PROD_SERVER = "https://minigrids.energy.gov.mw/api/v1";

  const PROD_REMOTE_API = Axios.create({
    baseURL: REMOTE_PROD_SERVER,
  });

  PROD_REMOTE_API.interceptors.request.use((config) => {
    const token = getTokenFromCookies("__auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return {
    PROD_REMOTE_API,
  };
})();

export default Config;
